import { mapValues, isObject, isNull, isEmpty, isEqual, some, every, size, isNaN, startCase } from "lodash"
import PropTypes from "prop-types"

export const INSTRUMENT_SIZE_SHAPE = PropTypes.shape({
  dollarValue: PropTypes.number,
  economicExposure: PropTypes.number,
})

export const nullIt = (items) => mapValues(items, (item) => {
  if (isObject(item)) {
    return nullIt(item)
  }
  return item === "" ? null : item
})

export function isCurrency(target) {
  return target.type && target.type === "currency"
}

export function isCountry(target) {
  return target.type && target.type === "country"
}

export function isClassification(target) {
  return !isNull(target.classificationId)
}

export function computeMinMax(min, max) {
  let error

  if (min && max) {
    if (!Number.isFinite(min) || !Number.isFinite(max)) {
      error = "Invalid value."
    } else if (max < min) {
      error = "Max should be >= Min."
    }
  }

  if (error) {
    min = null
    max = null
  }
  return { min, max, error }
}

export function rulesAreEmpty(active, applied) {
  return isEmpty(active) && isEmpty(applied)
}

export function rulesAreEqual(active, applied) {
  return isEqual(nullIt(active), nullIt(applied))
}

export function hasError(rules) {
  return some(rules, ({ error }) => !!error)
}

export function allRulesHaveNoValue(rules) {
  if (size(rules) === 0) {
    return false
  }
  return every(rules, ({ min, max }) => isNaN(parseFloat(min)) && isNaN(parseFloat(max)))
}

export function getTooltipType(rule) {
  return startCase(rule.classificationId || rule.contentSetId || rule.type)
}
